import React from 'react'
import DeclineContent from './DeclineContent'

export default function DeclinePage () {
  return (
    <div className='declinePage mobile'>
      <DeclineContent isMobile={true} />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/privacy_center/decline/DeclineMobile.jsx